import React, {PureComponent} from "react"
import {Col} from "react-bootstrap"
import PropTypes from "prop-types"
import {get} from "lodash"

import GeoInput, {SELECTED_VALUE_ICON} from "@irati-web/geolocation/src/components/GeoInput/GeoInput"
import {getQuery} from "@irati/utils/history"
import addQueryUtil from "../../utils/addQuery"

import PerksNearMeHeader from "../SearchAllByLocation/PerksNearMeHeader"

import {FlexRow, StyledSearchInput} from "./styled/Inputs"

class Inputs extends PureComponent {
  static propTypes = {
    searchTerm: PropTypes.string,
    onSearchInputChange: PropTypes.func,
    onGeoInputChange: PropTypes.func,
    geoInputLatLng: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    }),
    userLatLng: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    })
  }

  static defaultProps = {
    searchTerm: null,
    onSearchInputChange: () => {},
    onGeoInputChange: () => {},
    geoInputLatLng: null,
    userLatLng: null
  }

  state = {
    geoInputValue: null
  }

  componentDidMount = () => {
    const {geoInputLatLng} = this.props
    const query = getQuery()
    const geoInputDesc = get(query, "geoInputDesc")
    if (geoInputLatLng && geoInputDesc) {
      this.setState({
        geoInputValue: {
          latLng: geoInputLatLng,
          label: geoInputDesc,
          icon: SELECTED_VALUE_ICON
        }
      })
    } else {
      this.geoInput.selectCurrentLocation()
    }
  }

  handleGeoInputChange = ({latLng, isAccurate, desc}) => {
    addQueryUtil.addQuery({
      isLatLngAccurate: isAccurate,
      geoInputDesc: desc
    })
    this.props.onGeoInputChange(latLng)
  }


  render() {
    const {searchTerm, onSearchInputChange, userLatLng} = this.props
    const {geoInputValue} = this.state

    return (
      <FlexRow>
        <Col xsHidden smHidden md={5}>
          <PerksNearMeHeader />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <StyledSearchInput
            shouldFocusOnNavSearchClick
            value={searchTerm}
            onChange={onSearchInputChange} />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <GeoInput
            userLatLng={userLatLng}
            value={geoInputValue}
            onChange={this.handleGeoInputChange}
            ref={(gi) => { this.geoInput = gi }} />
        </Col>
      </FlexRow>
    )
  }
}

export default Inputs
